import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/brilliance-menu/brilliance-menu.js';
      import {ObcPaletteChangeEvent, ObcBrightnessChangeEvent, ObcLinkPaletteChangeEvent, ObcLinkBrightnessChangeEvent, ObcPalette, ObcBrillianceMenuVariant, ObcBrillianceInputVariant} from '@oicl/openbridge-webcomponents/dist/components/brilliance-menu/brilliance-menu.js';

      export interface Props {
     palette?: ObcPalette;
     brightness?: number;
     showLinkBrightness?: boolean;
     showLinkPalette?: boolean;
     showBrightness?: boolean;
     showPalette?: boolean;
     showNightPalette?: boolean;
     showDuskPalette?: boolean;
     showDayPalette?: boolean;
     showBrightPalette?: boolean;
     variant?: ObcBrillianceMenuVariant;
     brightnessUnit?: string;
     brightnessMax?: number;
     brightnessMinorStep?: number;
     brightnessMajorStep?: number;
     brightnessInputVariant?: ObcBrillianceInputVariant;
     showScreenControlLink?: boolean
   }

      
  
      export type {ObcPaletteChangeEvent, ObcBrightnessChangeEvent, ObcLinkPaletteChangeEvent, ObcLinkBrightnessChangeEvent, ObcPalette, ObcBrillianceMenuVariant, ObcBrillianceInputVariant} from '@oicl/openbridge-webcomponents/dist/components/brilliance-menu/brilliance-menu.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcBrillianceMenu',
  props: {
    palette: {},
    brightness: {},
    showLinkBrightness: { type: Boolean },
    showLinkPalette: { type: Boolean },
    showBrightness: { type: Boolean },
    showPalette: { type: Boolean },
    showNightPalette: { type: Boolean },
    showDuskPalette: { type: Boolean },
    showDayPalette: { type: Boolean },
    showBrightPalette: { type: Boolean },
    variant: {},
    brightnessUnit: {},
    brightnessMax: {},
    brightnessMinorStep: {},
    brightnessMajorStep: {},
    brightnessInputVariant: {},
    showScreenControlLink: { type: Boolean }
  },
  emits: ["palette-changed", "brightness-changed", "link-palette-changed", "link-brightness-changed", "screen-control-link-clicked"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onPaletteChanged: (event: ObcPaletteChangeEvent) => emit('palette-changed', event as ObcPaletteChangeEvent),
onBrightnessChanged: (event: ObcBrightnessChangeEvent) => emit('brightness-changed', event as ObcBrightnessChangeEvent),
onLinkPaletteChanged: (event: ObcLinkPaletteChangeEvent) => emit('link-palette-changed', event as ObcLinkPaletteChangeEvent),
onLinkBrightnessChanged: (event: ObcLinkBrightnessChangeEvent) => emit('link-brightness-changed', event as ObcLinkBrightnessChangeEvent),
onScreenControlLinkClicked: (event: CustomEvent) => emit('screen-control-link-clicked', event as CustomEvent)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-brilliance-menu',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})